import { motion } from "framer-motion";
import { Instagram, Mail } from "lucide-react";
import { useLang } from "../../i18n";
import { QR_IMG } from "../../data";

const socials = [
  { icon: Mail, label: "lilahcphotography@gmail.com", href: "mailto:lilahcphotography@gmail.com", testid: "footer-email" },
  { icon: Instagram, label: "@lilahcphotography", href: "https://instagram.com/lilahcphotography", testid: "footer-instagram" },
];

export const Footer = ({ onNavigate }) => {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="relative bg-[#1A181C] text-[#F9F6F0] px-6 md:px-12 pt-24 md:pt-36 pb-10">
      <p className="overline text-[#E8B059] mb-8">{t.footer.overline}</p>
      <motion.h2 initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.9 }}
        className="font-serif-display text-[13vw] md:text-[9vw] font-light leading-[0.86] tracking-tight mb-16">
        {t.footer.t1}<br /><span className="italic text-[#E2725B]">{t.footer.t2}</span>
      </motion.h2>

      <div className="grid md:grid-cols-2 gap-8 border-t border-[#F9F6F0]/15 pt-12">
        {socials.map((s) => (
          <a key={s.testid} data-testid={s.testid} href={s.href} target="_blank" rel="noreferrer" className="group flex items-center gap-4">
            <span className="flex items-center justify-center w-11 h-11 rounded-full border border-[#F9F6F0]/25 group-hover:bg-[#E2725B] group-hover:border-[#E2725B] transition-all duration-300">
              <s.icon className="w-4 h-4" strokeWidth={1.4} />
            </span>
            <span className="font-body text-sm md:text-base group-hover:text-[#E2725B] transition-colors">{s.label}</span>
          </a>
        ))}
      </div>

      <div className="mt-14 flex flex-col sm:flex-row items-start sm:items-center gap-6 border-t border-[#F9F6F0]/15 pt-12" data-testid="footer-qr">
        <a href="https://instagram.com/lilahcphotography" target="_blank" rel="noreferrer" className="bg-white p-3 rounded-xl shrink-0 transition-transform duration-300 hover:scale-[1.03]">
          <img src={QR_IMG} alt="Instagram QR — @lilahcphotography" className="w-32 h-32 md:w-36 md:h-36 object-contain" />
        </a>
        <div>
          <p className="overline text-[#E8B059] text-[0.6rem] mb-2">Follow along</p>
          <p className="font-serif-display text-3xl md:text-4xl font-light">@lilahcphotography</p>
          <p className="text-[#F9F6F0]/55 text-sm mt-2 max-w-xs">Scan the code with your phone camera to see my latest work on Instagram.</p>
        </div>
      </div>

      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 mt-20 text-[#F9F6F0]/45">
        <p className="font-serif-display italic text-2xl text-[#F9F6F0]">Lilah C. Photography</p>
        <div className="flex gap-8 overline text-[0.55rem]">
          <button data-testid="footer-book" onClick={() => onNavigate("book")} className="hover:text-[#E2725B] transition-colors">{t.footer.book}</button>
          <span>{t.footer.loc}</span>
          <span>© {new Date().getFullYear()}</span>
        </div>
      </div>
    </footer>
  );
};
